import * as types from './actionTypes';
import {api} from './api';
export function loginWithRememberMe(token) {
    return api({
        types: [types.LOGIN__USER_REMEMBER_ME_REQUEST, types.LOGIN__USER_REMEMBER_ME_SUCCESS, types.LOGIN__USER_REMEMBER_ME_FAILURE],
        uri: '/api/jwt/remember',
        sendJwtBearer: false,
        config: {
            method: 'POST',
            headers: {
                'AUTHORIZATION': `Bearer ${token}`
            }
        }
    });
}

//DONT WRAP THIS IN API IT IS USED IN THE REFRESH_JWT CALL
export function refreshToken(){
    return {
        types: [types.SESSION__REFRESH_TOKEN_REQUEST, types.SESSION__REFRESH_TOKEN_SUCCESS, types.SESSION__REFRESH_TOKEN_FAILURE],
        uri: '/api/jwt/refresh',
        config: {
            method: 'POST'
        }
    };
}

